import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUserHeart: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="user-heart, people, person, member, favorite"><path d="M12 20.25H4.75V19.5C4.75 15.4959 7.99594 12.25 12 12.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="7.75" r="4.5" stroke="currentColor" strokeWidth="1.5"/><path d="M21.2237 16.7646C21.2237 19.1763 17.8618 20.5 17.8618 20.5C17.8618 20.5 14.5 19.1763 14.5 16.7646C14.5 14.9571 16.307 13.881 17.8618 14.8852C19.4167 13.881 21.2237 14.9571 21.2237 16.7646Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconUserHeart;
